import { render } from "./person-select.vue?vue&type=template&id=6c0edd3d&scoped=true"
import script from "./person-select.vue?vue&type=script&lang=js"
export * from "./person-select.vue?vue&type=script&lang=js"

import "./person-select.vue?vue&type=style&index=0&id=6c0edd3d&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0edd3d"]])

export default __exports__